import { omit } from 'ramda';
import { useCallback, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

import { BaseDomain, QueryParam } from '~/common/types';

const CACHE_KEY = 'cached-queries';

let queryCache: { [key in BaseDomain]?: string } = {} as any;
const cachedQueries = localStorage.getItem(CACHE_KEY);
if (cachedQueries) {
  queryCache = JSON.parse(cachedQueries);
}

const updateCache = (content: any) => {
  localStorage.setItem(CACHE_KEY, JSON.stringify(content));
};

export const useCachedQuery = (domain?: BaseDomain, queryId?: string, encodedQuery?: string): (() => void) => {
  const [searchParams, setSearchParams] = useSearchParams();
  useEffect(() => {
    const cached = domain && queryCache[domain];
    // update cache
    if (domain) {
      queryCache = {
        ...queryCache,
        [domain]: queryId,
      };
      updateCache(queryCache);
    }
    if (!queryId && !encodedQuery && cached) {
      const queryParams = new URLSearchParams(searchParams);
      queryParams.set(QueryParam.QUERY, cached);
      setSearchParams(queryParams, { replace: true });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [domain, queryId]);

  const clearDomain = useCallback(() => {
    if (domain) {
      queryCache = omit([domain], queryCache);
      updateCache(queryCache);
    }
  }, [domain]);

  return clearDomain;
};
